import { FC, Fragment } from 'react';
import Typography from '@mui/material/Typography';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { APICharacterDataGraphRow } from '../types';
import { useTheme, makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../theme';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        noGraphText: {
            fontFamily: "Montserrat, Verdana, Sans-Serif !important",
            color: "#555 !important",
            textAlign: 'center',
            fontWeight: 500,
            fontSize: '0.8rem !important',
            textTransform: 'uppercase',
            padding: "40px 20px !important",
        }
    })
);

interface EXPDeltaGraphProps {
    data: APICharacterDataGraphRow[];
}

interface DataPoint {
    Label: string;
    EXP: number;
}

const parseData = (rows: APICharacterDataGraphRow[], isMobile: boolean): Array<DataPoint> => {
    let ret = Array<DataPoint>();
    if (isMobile && rows.length >= 8) {
        let len = rows.length - 8;
        rows = rows.slice(len, rows.length);
    }

    rows.forEach((value, idx) => {
        if (idx + 1 < rows.length) {
            let i = idx + 1;
            let expDiff = rows[i].TotalOverallEXP - value.TotalOverallEXP;

            ret.push({
                Label: rows[i].DateLabel,
                EXP: expDiff / 1000000000,
            })
        }
    })

    return ret
}

const EXPDeltaGraph: FC<EXPDeltaGraphProps> = (props: EXPDeltaGraphProps) => {
    const tme = useTheme<typeof theme>();
    const classes = useStyles();
    const matches = useMediaQuery(tme.breakpoints.down('sm'));

    if (props.data === undefined || props.data.length === 0) {
        return (<Fragment>
            <Typography className={classes.noGraphText}>
                Levelling information is only available for characters level 210+
            </Typography>
        </Fragment>);
    }

    const dataPoints = parseData(props.data, matches)
    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                width={700}
                height={300}
                data={dataPoints}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="Label" />
                <YAxis label={{ value: 'Experience (Billions)', angle: -90, position: 'insideLeft' }} />
                <Tooltip />
                <Bar dataKey="EXP" fill="#362d50" isAnimationActive={true} />
            </BarChart>
        </ResponsiveContainer>
    );
}

export default EXPDeltaGraph;
